import { RemoteDiagnosticsVddGenericStructure } from '@vi-iot/client';
import { Option } from '../../../../../projects/ui/components/dropdown-autocomplete/dropdown-autocomplete.component';

export enum TranslationIdValues {
  Month = 'TI_Month',
  Day = 'TI_Day',
  Year = 'TI_Year',
  Hour = 'TI_Hour',
  Minute = 'TI_Minute',
  Second = 'TI_Second',
}

export enum SemanticValues {
  ACTUATORVALUE = 'ACTUATORVALUE',
  BOOLEAN = 'BOOLEAN',
  BOOLEANCHOICE = 'BOOLEANCHOICE',
  DAY = 'DAY',
  DEFLEVEL = 'DEFLEVEL',
  DEFVALUE = 'DEFVALUE',
  DESCRIPTION = 'DESCRIPTION',
  ENTRIES = 'ENTRIES',
  ENUM = 'ENUM',
  ENUMCHOICE = 'ENUMCHOICE',
  HOUR = 'HOUR',
  IP = 'IP',
  MAC = 'MAC',
  MAX = 'HIGHHIGHLEVEL',
  METADATA = 'METADATA',
  MIN = 'LOWLOWLEVEL',
  MINUTE = 'MINUTE',
  MONTH = 'MONTH',
  RESERVED = 'RESERVED',
  SECOND = 'SECOND',
  SENSORAVG = 'SENSORAVG',
  SENSORMIN = 'SENSORMIN',
  SENSORMAX = 'SENSORMAX',
  SENSORVALUE = 'SENSORVALUE',
  STARTSTOPTEMP = 'STARTSTOPTEMP',
  STARTTIME = 'STARTTIME',
  STATUS = 'STATUS',
  STOPTIME = 'STOPTIME',
  VALUE = 'VALUE',
  VERSIONVALUE = 'VERSIONVALUE',
  YEAR = 'YEAR',
}

export enum DopnameValues {
  DisableEnable = 'DisableEnable',
  FalseTrue = 'FalseTrue',
  InactiveActive = 'InactiveActive',
  IpAddress = 'IpAddress',
  MacAddress = 'MacAddress',
  NoYes = 'NoYes',
  OffOn = 'OffOn',
  Version = 'Version',
}

export enum LongnameValues {
  Structure = 'Structure',
  Value = 'Value',
  WeekDay = 'WeekDay',
}

export enum TypeValues {
  INT32 = 'INT32',
  FLOAT32 = 'FLOAT32',
  eTABLE = 'eTABLE',
}

export enum DataKeyValues {
  Dopname = 'dopname',
  Longname = 'longname',
  Semantic = 'semantic',
  Type = 'type',
  Unit = 'unit',
  Value = 'value',
  TranslationId = 'translationid',
}

export enum NameValues {
  DataRecor = 'PA_DataRecor',
  DataRecorValue = 'PA_DataRecor/PA_Value',
  DataStrucValue = 'PA_Struc/PA_Value',
}

export enum PathValues {
  DataRecor = 'DataRecor',
  Struc = 'Struc',
}

export enum UnitValues {
  Day = 'd',
  Hour = 'h',
  Minute = 'min',
  Month = 'm',
  Second = 's',
  Year = 'y',
}

export enum TimeType {
  StartTime = 'StartTime',
  StopTime = 'StopTime',
}

export interface VDDParameterViewValue extends Option {
  value: string;
  viewValue: string;
  viewValueTwo?: string;
  viewValueThree?: string;
  isWrite: boolean;
  isRead: boolean;
}

export interface StartStopTempData {
  structure: RemoteDiagnosticsVddGenericStructure[];
  entriesValue: string;
}

export enum VddNames {
  ViessmannIdentificationNumber = 'ViessmannIdentificationNumber',
  ElectronicTraceabilityNumber = 'ElectronicTraceabilityNumber',
  HydraulicSeparatorTemperatureSensor = 'HydraulicSeparatorTemperatureSensor',
  WaterPressureSensor = 'WaterPressureSensor',
  StatusDtcList = 'StatusDtcList',
  StatusDtcHistory = 'StatusDtcHistory',
  OutsideTemperatureSensor = 'OutsideTemperatureSensor',
  MixerTwoCircuitFlowTemperatureSensor = 'MixerTwoCircuitFlowTemperatureSensor',
  MixerTwoCircuitCurrentTemperatureSetpoint = 'MixerTwoCircuitCurrentTemperatureSetpoint',
  MixerOneCircuitTimeScheduleThursday = 'MixerOneCircuitTimeScheduleThursday',
  MixerOneCircuitTimeScheduleMonday = 'MixerOneCircuitTimeScheduleMonday',
  MixerFiveCircuitFlowTemperatureSensor = 'MixerFiveCircuitFlowTemperatureSensor',
  InfoDtcList = 'InfoDtcList',
  HydraulicMatrix = 'HydraulicMatrix',
  HolidayAtHomePhaseCircuitTwo = 'HolidayAtHomePhaseCircuitTwo',
  FreezeFrame = 'FreezeFrame',
  FlowTemperatureSensor = 'FlowTemperatureSensor',
  DomesticHotWaterTimeScheduleTuesday = 'DomesticHotWaterTimeScheduleTuesday',
  DomesticHotWaterTimeScheduleMonday = 'DomesticHotWaterTimeScheduleMonday',
  DomesticHotWaterTemperatureSetpoint = 'DomesticHotWaterTemperatureSetpoint',
  DomesticHotWaterSensor = 'DomesticHotWaterSensor',
  DomesticHotWaterCirculationPumpMode = 'DomesticHotWaterCirculationPumpMode',
  DomesticHotWaterCirculationPump = 'DomesticHotWaterCirculationPump',
  BusIdentification = 'BusIdentification',
  GatewayMac = 'GatewayMac',
  GatewayRemoteIp = 'GatewayRemoteIp',
  MacAddressLan = 'MacAddressLan',
  GatewayEthernetIp = 'GatewayEthernetIp',
  SolarRoofTemperatureSensor = 'SolarRoofTemperatureSensor',
}

export enum VINRequestParameterValues {
  ViessmannIdentificationNumber = 'ViessmannIdentificationNumber',
  ElectronicTraceabilityNumber = 'ElectronicTraceabilityNumber',
}
